import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../contexts/ModalContext';
import { buildGroupProps } from '../../utils/elementisUtils';

import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';

const BASE = 'SHARED_COMPONENTS.UNCONFIRMED_CHANGES_MODAL';

type Props = {
  id: string;
  onConfirm: () => void;
};

export default function UnconfirmedChangesDialog({ id, onConfirm }: Props) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  const handleClose = () => {
    closeModal(id);
  };

  const handleConfirmation = () => {
    onConfirm();
    handleClose();
  };

  return (
    <Dialog id={id} modal size="sm" onClose={handleClose} aria-label={t(`${BASE}.A11Y_LABEL`)}>
      <Dialog.Header
        title={t(`${BASE}.HEADER.TITLE`)}
        onClose={handleClose}
        aria-label={t(`${BASE}.HEADER.A11Y_LABEL`)}
        danger
      />
      <Dialog.Body>{t(`${BASE}.BODY.TEXT`)}</Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsRight={buildGroupProps(
          <>
            <Button prominence="neutral" onClick={handleClose} key="cancel">
              {t(`${BASE}.FOOTER.ACTIONS.CANCEL`)}
            </Button>
            <Button prominence="danger" onClick={handleConfirmation} key="confirm">
              {t(`${BASE}.FOOTER.ACTIONS.CONFIRM`)}
            </Button>
          </>,
        )}
      />
    </Dialog>
  );
}
